import service1 from "../Assests/OurServiceImages/service1.png";
import service2 from "../Assests/OurServiceImages/service2.png";
import service3 from "../Assests/OurServiceImages/service3.png";
import service4 from "../Assests/OurServiceImages/service4.png";
import service5 from "../Assests/OurServiceImages/service5.png";
import service6 from "../Assests/OurServiceImages/service6.png";
import service7 from "../Assests/OurServiceImages/service7.png";
import product from "../Assests/OurServiceImages/product.png";
import IT from "../Assests/OurServiceImages/IT.png";
import AI from "../Assests/OurServiceImages/AI.png";
import ux from "../Assests/OurServiceImages/ux.png";
import bigData from "../Assests/OurServiceImages/bigData.png";
import blockchain from "../Assests/OurServiceImages/blockchain.png";
import iot from "../Assests/OurServiceImages/iot.png";

export const servicePageData = [
  {
    img: service1,
    icon: product,
    heading: "Product Development",
    subHeading: "Accelerate Your Product Innovation with Techclockers",
    points: [
      {
        pointA: "Tailored Solutions for Your Vision",
        pointB: "Seamless Collaboration for Success",
        pointC: "Expertise That Saves Time and Resources",
        pointD: "Empowering Startups and Small Businesses",
        pointE: "Agile Scaling for Larger Enterprises",
      },
    ],
  },
  {
    img: service2,
    icon: IT,
    heading: "IT-Services",
    subHeading:
      "Transform Your Business with Hassle-Free IT Services from Techclockers.",
    points: [
      {
        pointA: "All-in-One IT Solutions on Subscription",
        pointB: "Tailored Packages for Your Business",
        pointC: "Embrace the Power of the Cloud",
        pointD: "Security and Data Protection You Can Trust",
        pointE: "Focus on Core Competencies",
      },
    ],
  },
  {
    img: service3,
    icon: AI,
    heading: "A.I and Machine Learning",
    subHeading:
      "Empowering Your Business with AI and Machine Learning Solutions",
    points: [
      {
        pointA: "Ready-to-Use AI Models and Infrastructure",
        pointB: "Diverse Capabilities for Enhanced Applications",
        pointC: "Seamless Integration with API Access",
        pointD: "Democratizing AI Technology",
        pointE: "Accelerated Time-to-Market and Enhanced Performance",
      },
    ],
  },
  {
    img: service4,
    icon: ux,
    heading: "UI/UX Services",
    subHeading:
      "Elevate User Experience with Expert UI/UX Design Services",
    points: [
      {
        pointA: "Access to Skilled Designers",
        pointB: "Comprehensive Design Solutions",
        pointC: "Tailored to Your Unique Needs",
        pointD: "Elevate User Satisfaction and Engagement",
        pointE: "Cost-Effective Alternative",
      },
    ],
  },
  {
    img: service5,
    icon: bigData,
    heading: "BI, Big data& Predictive Analysis",
    subHeading:
      "Unleash the Power of Data with Advanced Analytics and Big Data Solutions",
    points: [
      {
        pointA: "Seamless Data Management and Analysis",
        pointB: "Harnessing the Potential of Big Data",
        pointC: "Data-Driven Decision-Making",
        pointD: "Deeper Insights, Optimal Performance",
        pointE: "Cost-Effective Scalability",
      },
    ],
  },
  {
    img: service6,
    icon: blockchain,
    heading: "Blockchain and Web3",
    subHeading:
      "Seamless Blockchain Solutions for the Future of Innovation",
    points: [
      {
        pointA: "Hassle-Free Blockchain Application Development",
        pointB: "Rapid Integration via User-Friendly APIs",
        pointC: "Multi-Protocol Support for Versatile Applications",
        pointD: "Cost-Effective Experimentation and Accelerated Development",
        pointE: "Leveraging Blockchain Benefits with Ease",
      },
    ],
  },
  {
    img: service7,
    heading: "IoT",
    icon: iot,
    subHeading:
      "Empowering the Internet of Things (IoT) Revolution with Techclockers",
    points: [
      {
        pointA: "Comprehensive IoT Application Management",
        pointB: "A Full Suite of IoT Services",
        pointC: "Cost Savings and Scalability",
        pointD: "Versatility Across Industries",
        pointE: "Focus on Core Business",
      },
    ],
  },
];
